import { PaymentRequestPassiveExportRequest } from './PaymentRequestPassiveReportGenerator';
import { PaymentRequestPassiveReportGenerator } from './PaymentRequestPassiveReportGenerator';

export const generatePaymentRequestPassivePDF = async (
  selectedRequest: PaymentRequestPassiveExportRequest,
  userName: string,
  imageBase64: string,
  payouts?: any,
) => {
  const generator = new PaymentRequestPassiveReportGenerator({
    userName,
    imageBase64,
    title: `Liquidación Devolución de Pasivos${selectedRequest.id || selectedRequest.sourceId ? ` - Solicitud ${selectedRequest.id || selectedRequest.sourceId}` : ''}`,
    fileName: `Liquidacion-Devolucion-Pasivos${selectedRequest.id || selectedRequest.sourceId ? `-${selectedRequest.id || selectedRequest.sourceId}` : ''}.pdf`,
    selectedRequest,
    payouts,
  });
  await generator.generate();
};
